import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  dialog: {
    p: '10',
    borderRadius: '3xl',
  },
  overlay: {
    bg: ['white', 'grey.400'],
  },
  body: {
    px: '0',
    py: '5',
  },
  header: {
    px: '0',
    pb: '2',
  },
  footer: {
    px: '0',
  },
});

export const styleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    sm: {
      dialog: {
        maxW: 'container.sm',
      },
    },
    md: {
      dialog: {
        maxW: 'container.md',
      },
    },
    lg: {
      dialog: {
        maxW: 'container.lg',
      },
    },
    xl: {
      dialog: {
        maxW: 'container.xl',
      },
    },
  },
  defaultProps: {
    size: 'md',
  },
});
